// QuestionTextRenderer.jsx
import React, { useMemo } from "react";
import Latex from "react-latex";
import he from "he";

// Stateless image renderer
const QuestionImage = ({ src, index }) => (
  <img
    key={index}
    src={src}
    alt={`Question Image ${index}`}
    onLoad={(e) => {
      const { naturalWidth, naturalHeight } = e.target;
      if (naturalWidth > 100 || naturalHeight > 100) {
        e.target.style.height = "100px";
      }
    }}
    style={{ width: "auto", height: "auto", margin: "5px" }}
  />
);

// Memoized component for rendering a single question's text
const QuestionTextRenderer = React.memo(({ questionText }) => {
  const content = useMemo(() => {
    const decoded = he.decode(questionText);
    const segments = decoded.split(/(imgsrc=[^ ]+)/g);
    return segments.map((segment, index) => {
      if (segment.startsWith("imgsrc=")) {
        const imageUrl = segment.replace("imgsrc=", "");
        return <QuestionImage key={index} src={imageUrl} index={index} />;
      }
      return (
        <span key={index} className="truncated-text-2">
          <Latex>{segment}</Latex>
        </span>
      );
    });
  }, [questionText]);

  return <>{content}</>;
});

export default QuestionTextRenderer;
